export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_FAILED = 'AUTH_FAILED'
export const AUTH_IS_FETCHING = 'AUTH_IS_FETCHING'

export const ORGANIZATION_SUCCESS = 'ORGANIZATION_SUCCESS'
export const ORGANIZATION_IS_FETCHING = 'ORGANIZATION_IS_FETCHING'
export const ORGANIZATION_LIST = 'ORGANIZATION_LIST'

export const STORAGE_SUCCESS = 'STORAGE_SUCCESS'
export const STORAGE_IS_FETCHING = 'STORAGE_IS_FETCHING'
export const STORAGE_IS_DELETEING = 'STORAGE_IS_DELETEING'

export const STORAGE_UPDATE_CONTENT_TABLE = 'UPDATE_CONTENT_TABLE'
export const STORAGE_UPDATE_TABLE = 'STORAGE_UPDATE_TABLE'
export const STORAGE_ADD_TAG = 'STORAGE_ADD_TAG'
export const STORAGE_REMOVE_TAG = 'STORAGE_REMOVE_TAG'
export const STORAGE_ADD_TAGS = 'STORAGE_ADD_TAGS'
export const STORAGE_FILTER = 'STORAGE_FILTER'
export const STORAGE_FILTER_CLEAR = 'STORAGE_FILTER_CLEAR'
export const STORAGE_FILTERS_SEARCH = 'STORAGE_FILTERS_SEARCH'
export const STORAGE_FILTERS_PAGE = 'STORAGE_FILTERS_PAGE'
export const STORAGE_FILTERS_PAGE_SIZE = 'STORAGE_FILTERS_PAGE_SIZE'
export const STORAGE_FILTERS_SORT = 'STORAGE_FILTERS_SORT'
export const STORAGE_FILTERS_ADD_TYPE = 'STORAGE_FILTER_ADD_TYPE'
export const STORAGE_FILTERS_REMOVE_TYPE = 'STORAGE_FILTER_REMOVE_TYPE'

export const STORAGE_TABLE_DELETE_ITEM = 'STORAGE_TABLE_DELETE_ITEM'
export const STORAGE_TABLE_ADD_ITEM = 'STORAGE_TABLE_ADD_ITEM'

export const CHANNEL_SUCCESS = 'CHANNEL_SUCCESS'
export const CHANNEL_IS_FETCHING = 'CHANNEL_IS_FETCHING'
export const CHANNEL_IS_FETCHING_ID = 'CHANNEL_IS_FETCHING_ID'
export const CHANNEL_CREATE = 'CHANNEL_CREATE'
export const CHANNEL_UPDATE = 'CHANNEL_UPDATE'
export const CHANNEL_DELETE = 'CHANNEL_DELETE'
export const CHANNEL_SELECT = 'CHANNEL_SELECT'
export const CHANNEL_SELECT_DIRECTORY = 'CHANNEL_SELECT_DIRECTORY'
export const CHANNEL_SELECT_PREVIOUS_DIRECTORY = 'CHANNEL_SELECT_PREVIOUS_DIRECTORY'
export const CHANNEL_CREATE_DIRECTORY = 'CHANNEL_CREATE_DIRECTORY'
export const CHANNEL_CREATE_SMART_DIRECTORY = 'CHANNEL_CREATE_SMART_DIRECTORY'
export const CHANNEL_EDIT_DIRECTORY = 'CHANNEL_EDIT_DIRECTORY'
export const CHANNEL_ASSIGN_FILES = 'CHANNEL_ASSIGN_FILES'
export const CHANNEL_UNASSIGN_FILES = 'CHANNEL_UNASSIGN_FILES'
export const CHANNEL_DELETE_DIRECTORIES = 'CHANNEL_DELETE_DIRECTORIES'
export const CHANNEL_TABLE = 'CHANNEL_TABLE'
export const CHANNEL_ADD_USERS = 'CHANNEL_ADD_USERS'
export const CHANNEL_DELETE_USERS = 'CHANNEL_DELETE_USERS'
export const CHANNEL_ADD_GROUPS = 'CHANNEL_ADD_GROUPS'
export const CHANNEL_DELETE_GROUPS = 'CHANNEL_DELETE_GROUPS'

export const MODAL_STORAGE_UPLOAD = 'MODAL_STORAGE_UPLOAD'
export const MODAL_STORAGE_EDIT = 'MODAL_STORAGE_EDIT'
export const MODAL_STORAGE_UPDATE = 'MODAL_STORAGE_UPDATE'
export const MODAL_STORAGE_DELETE = 'MODAL_STORAGE_DELETE'
export const MODAL_STORAGE_DELETE_LINKS = 'MODAL_STORAGE_DELETE_LINKS'

export const MODAL_CHANNEL_CREATE = 'MODAL_CHANNEL_CREATE'
export const MODAL_CHANNEL_EDIT = 'MODAL_CHANNEL_EDIT'
export const MODAL_STORAGE_DIRECTORY_CREATE = 'MODAL_STORAGE_DIRECTORY_CREATE'
export const MODAL_STORAGE_DIRECTORY_EDIT = 'MODAL_STORAGE_DIRECTORY_EDIT'
export const MODAL_STORAGE_DIRECTORY_SMART_CREATE = 'MODAL_STORAGE_DIRECTORY_SMART_CREATE'
export const MODAL_STORAGE_DIRECTORY_SMART_EDIT = 'MODAL_STORAGE_DIRECTORY_SMART_EDIT'

export const MODAL_USER_CREATE = 'MODAL_USER_CREATE'
export const MODAL_USER_DELETE = 'MODAL_USER_DELETE'
export const MODAL_USER_EDIT = 'MODAL_USER_EDIT'

export const MODAL_GROUP_CREATE = 'MODAL_GROUP_CREATE'
export const MODAL_GROUP_DELETE = 'MODAL_GROUP_DELETE'
export const MODAL_GROUP_EDIT = 'MODAL_GROUP_EDIT'

export const MODAL_TAGS = 'MODAL_TAGS'

export const TAG_IS_FETCHING = 'TAG_IS_FETCHING'
export const TAG_GET = 'TAG_GET'
export const TAG_CREATE = 'TAG_CREATE'
export const TAG_REMOVE = 'TAG_REMOVE'
export const TAG_EDIT = 'TAG_EDIT'

/**
 * Upload types
 */

export const UPLOAD_ACCEPTED_FILES_ADD = 'UPLOAD_ACCEPTED_FILES_ADD'
export const UPLOAD_ACCEPTED_FILE_REMOVE = 'UPLOAD_ACCEPTED_FILE_REMOVE'
export const UPLOAD_CLEAR = 'UPLOAD_CLEAR'
export const UPLOAD_UPLOADED_FILES_ADD = 'UPLOAD_UPLOADED_FILES_ADD'
export const UPLOAD_UPLOADED_FILES_REMOVE = 'UPLOAD_UPLOADED_FILES_REMOVE'
export const UPLOAD_TABLE_UPDATE = 'UPLOAD_TABLE_UPDATE'
export const UPLOAD_TABLE_UPDATE_BY_ID = 'UPLOAD_TABLE_UPDATE_BY_ID'
export const UPLOAD_TABLE_REFRESH = 'UPLOAD_TABLE_REFRESH'
export const UPLOAD_DEFAULTS = 'UPLOAD_DEFAULTS'
export const UPLOAD_TABLE_REFRESH_FILE_TAG = 'UPLOAD_TABLE_REFRESH_FILE_TAG'

/**
 * User groups types
 */

export const GROUP_SUCCESS = 'GROUP_CUCCESS'
export const GROUP_CREATE = 'GROUP_CREATE'
export const GROUP_DELETE = 'GROUP_DELETE'
export const GROUP_EDIT = 'GROUP_EDIT'

/**
 * User types
 */

export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_IS_FETCHING = 'USER_IS_FETCHING'
export const USER_IS_UPDATING = 'USER_IS_UPDATING'
export const USER_PASSWORD_IS_UPDATING = 'USER_PASSWORD_IS_UPDATING'
export const USER_LIST_IS_FETCHING = 'USER_LIST_IS_FETCHING'
export const USER_GET_ALL = 'USER_GET_ALL'
export const USER_TABLE = 'USER_TABLE'
export const USER_DELETE_ARRAY = 'USER_DELETE_ARRAY'
export const USER_DELETE_ID = 'USER_DELETE_ID'
export const USER_UPDATE_ID = 'USER_UPDATE_ID'
export const USER_CREATE = 'USER_CREATE'

export const USER_STATUS_UPDATING = 'USER_STATUS_UPDATING'

/**
 * Download types
 */

export const DOWNLOAD_FILE_ADD = 'DOWNLOAD_FILE_ADD'
export const DOWNLOAD_FILES_ADD = 'DOWNLOAD_FILES_ADD'
export const DOWNLOAD_FILE_UPDATE = 'DOWNLOAD_FILE_UPDATE'

export const DOWNLOAD_CLEAR = 'DOWNLOAD_CLEAR'

/**
 * Divisions types
 */

export const DIVISION_IS_FETCHING = 'DIVISION_IS_FETCHING'
export const DIVISION_LIST = 'DIVISION_LIST'
export const DIVISION_TABLE = 'DIVISION_TABLE'
export const DIVISION_CREATE = 'DIVISION_CREATE'
export const DIVISION_DELETE_BY_ID = 'DIVISION_DELETE_BY_ID'
export const DIVISION_UPDATE_BY_ID = 'DIVISION_UPDATE_BY_ID'



// WEBPACK FOOTER //
// ./src/store/types.js